import { EMPTY_FIELD } from 'constants/emptyField';

import { useRecordContext } from 'react-admin';
import { Typography } from 'shared/mui/Typography';
import { OrderReportData } from 'types/embedded/orderReport';
import { formatCurrency } from 'utils';

export const OrdersReportListTotalAmountField: React.FC = () => {
  const record = useRecordContext<OrderReportData>();

  if (!record || !record.totalAmount) {
    return EMPTY_FIELD;
  }

  return (
    <>
      <Typography component="span" variant="body2">
        {formatCurrency(record?.totalAmount as Intl.StringNumericLiteral)}
      </Typography>{' '}
      <Typography component="span" sx={{ fontWeight: 500 }} variant="body2">
        {record?.currency}
      </Typography>
    </>
  );
};
